export default "__VITE_ASSET__CCX2$pxV__"